<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>排单情况列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                ref="form"
                :model="form"
                :inline="true"
                class="demo-form-inline"
              >
                <div style="display: flex; flex-direction: row">
                  <div class="_let-item" style="height: 180px">
                    <el-form-item>
                      <el-input
                        v-model="form.supply_name"
                        size="small"
                        placeholder="商家"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.city"
                        size="small"
                        multiple
                        placeholder="选择城市"
                        @keyup.native.enter="search"
                      >
                        <el-option value="" label="全部"></el-option>
                        <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-if="resData"
                        v-model="form.pgid"
                        size="small"
                        multiple
                        filterable
                        placeholder="代采组"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in pgOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-if="resData"
                        v-model="form.pg_member_id"
                        size="small"
                        filterable
                        placeholder="代采员"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in memberOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-input
                        v-model="form.goods_name"
                        size="small"
                        placeholder="商品名称"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-input
                        v-model="form.goods_no"
                        size="small"
                        placeholder="商品货号"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.data_type"
                        size="small"
                        placeholder="数据展示"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in dataOption"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.return_day"
                        size="small"
                        placeholder="预计回货天数"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in dayOption"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.handle_source"
                        size="small"
                        placeholder="跟进来源"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in source"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.goods_sale_status"
                        size="small"
                        placeholder="商品状态"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in goodsSaleStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.sku_status"
                        size="small"
                        placeholder="sku状态"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in skuStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div style="height: 80px !important">
                    <el-form-item>
                      <div class="special-filter-box">
                        <div class="_filter-box">
                          <div class="_filter-box-item">
                            <div class="_filter-title">单款欠货数量:</div>
                            <el-input
                              v-model="form.min"
                              size="small"
                              style="width: 100px"
                              placeholder="请输入最小值"
                            ></el-input>
                            <div style="line-height: 32px">至</div>
                            <el-input
                              v-model="form.max"
                              size="small"
                              style="width: 100px"
                              placeholder="请输入最大值"
                            ></el-input>
                          </div>
                          <div class="_filter-box-item">
                            <div class="_filter-title">
                              待代采数量&nbsp;&nbsp;&nbsp;:
                            </div>
                            <el-input
                              v-model="form.plan_num_min"
                              size="small"
                              style="width: 100px"
                              placeholder="请输入最小值"
                            ></el-input>
                            <div style="line-height: 32px">至</div>
                            <el-input
                              v-model="form.plan_num_max"
                              size="small"
                              style="width: 100px"
                              placeholder="请输入最大值"
                            ></el-input>
                          </div>
                          <div class="_filter-box-item">
                            <div class="_filter-title">
                              总数量&nbsp;&nbsp;&nbsp;:
                            </div>
                            <el-input
                              v-model="form.total_min"
                              size="small"
                              style="width: 100px"
                              placeholder="请输入最小值"
                            ></el-input>
                            <div style="line-height: 32px">至</div>
                            <el-input
                              v-model="form.total_max"
                              size="small"
                              style="width: 100px"
                              placeholder="请输入最大值"
                            ></el-input>
                          </div>
                        </div>
                        <div
                          style="
                            margin-top: 40px;
                            margin-left: 10px;
                            width: 70px;
                          "
                        >
                          <el-select v-model="form.type" size="small">
                            <el-option :value="1" label="且"></el-option>
                            <el-option :value="2" label="或"></el-option>
                          </el-select>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item label="代采计划生成时间：" label-width="140px">
                  <el-date-picker
                    v-model="form.create_time"
                    size="small"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="form.is_reminder" value="1" label="4">
                    客服有催单</el-checkbox
                  >
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="form.is_strength" value="1" label="4">
                    实力档口</el-checkbox
                  >
                </el-form-item>
                <br />
                <el-form-item label="平均计划开单时长(天)">
                  <el-input
                    v-model="form.avg_plan_time_min"
                    placeholder="开始"
                    size="small"
                    style="width: 100px"
                  ></el-input>
                  至
                  <el-input
                    v-model="form.avg_plan_time_max"
                    placeholder="结束"
                    size="small"
                    style="width: 100px"
                  ></el-input>
                </el-form-item>
                <el-form-item label="平均订单入库时长(天)">
                  <el-input
                    v-model="form.avg_stocking_time_min"
                    placeholder="开始"
                    size="small"
                    style="width: 100px"
                  ></el-input>
                  至
                  <el-input
                    v-model="form.avg_stocking_time_max"
                    placeholder="结束"
                    size="small"
                    style="width: 100px"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="small" type="primary" @click="search">
                    查询</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
            position: relative;
          "
        >
          <div>数据列表：</div>
          <div style="position: absolute; right: 0; top: 10px">
            <el-button
              size="small"
              type="primary"
              @click="editScheduleDay([], 1)"
            >
              批量编辑天数</el-button
            >
            <el-button size="small" type="success" @click="output">
              导出</el-button
            >
          </div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="resData.list"
            tooltip-effect="dark"
            border
            style="width: 100%"
            :cell-class-name="addBackground"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              fixed="left"
              align="center"
              width="55"
            >
            </el-table-column>
            <el-table-column prop="goods_img" label="图片" align="center">
              <template slot-scope="scope">
                <div style="width: 70px; height: 70px">
                  <img
                    :src="scope.row.imgs[0]"
                    style="width: 100%; height: 100%"
                    @click="showImages(scope.row.imgs)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              show-overflow-tooltip
              align="center"
            />
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_member_name"
              label="代采员"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_status"
              label="商品状态"
              show-overflow-tooltip
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="paln_billing_avg"
              label="平均计划开单时长(天)"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="order_stockin_avg"
              label="平均订单入库时长(天)"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop=""
              label="颜色"
              show-overflow-tooltip
              align="center"
              width="122"
            >
              <template v-if="scope.row.sku" slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.sku"
                  :key="index"
                  class="table-div"
                >
                  <p>
                    {{ item.co_val }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="尺码"
              show-overflow-tooltip
              align="center"
              width="122"
            >
              <template v-if="scope.row.sku" slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.sku"
                  :key="index"
                  class="table-div"
                >
                  <p>
                    {{ item.si_val }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="SKU状态"
              show-overflow-tooltip
              align="center"
              width="122"
            >
              <template v-if="scope.row.sku" slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.sku"
                  :key="index"
                  class="table-div"
                >
                  <p>
                    {{ item.is_sale }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="待代采"
              show-overflow-tooltip
              align="center"
              width="105"
            >
              <template v-if="scope.row.sku" slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.sku"
                  :key="index"
                  class="table-div"
                >
                  <p>
                    {{ item.plan_num }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="欠货"
              show-overflow-tooltip
              align="center"
              width="105"
            >
              <template v-if="scope.row.sku" slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.sku"
                  :key="index"
                  class="table-div"
                >
                  <p>
                    {{ item.owe_num }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="总数量"
              show-overflow-tooltip
              align="center"
              width="105"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.sku" class="table-div">
                  {{ calcuatorSku(scope.row.sku) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="用户排单"
              show-overflow-tooltip
              align="center"
              width="105"
            >
              <template v-if="scope.row.sku" slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.sku"
                  :key="index"
                  class="table-div"
                >
                  <p>
                    {{ item.pd_num }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :cell-style="{ 'background-color': 'yellow' }"
              prop="estimated_return_day"
              label="预计回货天数"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.is_stop_sale == 1">档口停售</span>
                <span v-if="scope.row.is_stop_sale == 0">{{
                  scope.row.estimated_return_day
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="handle_admin"
              label="跟进人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_source"
              label="跟进来源"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_time"
              label="跟进时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop=""
              label="操作"
              align="center"
              width="100"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="editScheduleDay([scope.row.goods_no], 0)"
                  >编辑天数</el-button
                >
                <p
                  v-if="scope.row.is_reminder == 1"
                  style="margin-top: 5px; color: red"
                  type="danger"
                  size="small"
                >
                  客服催单<br />{{ scope.row.gr_update_time }}
                </p>
                <el-button
                  v-if="scope.row.is_stop_sale == 0"
                  style="margin-left: 0 !important"
                  type="danger"
                  size="small"
                  @click="addEmergency(scope.row)"
                  >断货并<br />加入急救箱</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import PreviewImage from "../../components/PreviewImage";
import { CITY } from "@/const/CommonConst";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    PreviewImage,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchMember();
      vm.fetchPg();
      if (vm.$route.params.goods_no) {
        vm.$set(vm.form, "goods_no", vm.$route.params.goods_no);
        vm.$set(vm.form, "min", "");
        vm.fetchData();
      }
    });
  },
  data() {
    return {
      showbox: false,
      images: [],
      hideHeader: false,
      resData: { list: [], count: 0 },
      goods_nos: [],
      memberOption: [],
      pgOption: [],
      citys: CITY,
      goodsSaleStatus: [
        {
          value: 1,
          label: "正常/上架",
        },
        {
          value: 2,
          label: "正常/下架",
        },
        {
          value: 3,
          label: "断货/下架",
        },
      ],
      skuStatus: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 2,
          label: "禁用",
        },
      ],
      source: [
        {
          key: 1,
          label: "代采APP",
        },
        {
          key: 2,
          label: "ERP",
        },
        {
          key: 3,
          label: "爆版",
        },
      ],
      dayOption: [
        {
          key: 1,
          label: "欠货",
        },
        {
          key: 2,
          label: "待代采",
        },
      ],
      dataOption: [
        {
          key: 1,
          label: "未录入",
        },
        {
          key: 2,
          label: "未过期",
        },
        {
          key: 3,
          label: "已过期",
        },
      ],
      form: {
        create_time: [],
        status: "",
        referer: 1,
        min: 10,
        type: 1,
        city: [],
      },
      loading: false, // 加载动画是否显示
      url: "/erp/WcgPlan/scheduleList",
      status: "",
      curPage: 1,
      loading: false,
      tableLoading: false,
      filterFold: false,
      w: 8,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    // 修正一下样式的问题
    const w = document.body.offsetWidth;
    if (w > 1300 && w < 1600) {
      this.w = 8;
    }
    if (w >= 1600) {
      this.w = 6;
    }
  },
  methods: {
    fetchPg() {
      this.$http.post("/erp/Common/selectPg").then((res) => {
        if (res.data.code != 200) {
          return this.$message.error(res.data.msg);
        }
        this.pgOption = res.data.data;
      });
    },
    fetchMember() {
      this.$http.post("/erp/Common/getPurchaseMember").then((res) => {
        if (res.data.code != 200) {
          return this.$message.error(res.data.msg);
        }
        this.memberOption = res.data.data;
      });
    },
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    addBackground({ row, column, columnIndex }) {
      if (
        columnIndex === 12 &&
        row.need_red == 1 &&
        row.estimated_return_day == 0 &&
        row.estimated_return_time > 0
      ) {
        return "warning-row";
      }
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    editScheduleDay(goods_no, type) {
      this.$prompt("请输入排单天数", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showInput: true,
      })
        .then(({ value }) => {
          const val = parseInt(value);
          if (isNaN(val) || val < 0) {
            return this.$message.error("请输入正整数");
          }
          if (type == 1) {
            goods_no = this.goods_nos;
          }
          const arg = { goods_no, day: val };
          this.loading = true;
          this.$http
            .post("/erp/WcgPlan/editEstimatedReturnTime", arg)
            .then((res) => {
              this.loading = false;
              if (res.data.code != 200) {
                return this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
              this.fetchData();
              return this.$message({
                type: "success",
                message: "操作成功",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.goods_nos = [];
      val.forEach((v) => {
        this.goods_nos.push(v.goods_no);
      });
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    selectStatus(key) {
      this.form.status = this.status = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    calcuatorSku(sku) {
      let total = 0;
      sku.forEach((item) => {
        total += Number(Number(item.owe_num) + Number(item.plan_num));
      });
      return total;
    },
    addEmergency(row) {
      const params = {
        supply_id: row.supply_id,
        pgid: row.pgid,
        goods_no: row.goods_no,
      };
      this.$http
        .post("/erp/WcgPlan/goodsStockAndCancel", params)
        .then((res) => {
          if (res.data.code != 200) {
            return this.$message.error(res.data.msg);
          }
          this.$message.success("操作成功");
          this.fetchData();
        });
    },
  },
};
</script>

<style>
.special-filter-box {
  width: 420px;
  background-color: #ddd;
  display: flex;
  flex-direction: row;
}

._filter-box {
  display: flex;
  flex-direction: column;
}

._filter-box-item {
  display: flex;
  flex-direction: row;
}

._filter-title {
  line-height: 32px;
  width: 100px;
  font-size: 14px;
}

._let-item {
  height: 80px !important;
}

._let-item .el-form-item {
  width: 180px;
  height: 32px;
  margin-bottom: 5px !important;
}
</style>
<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.viewer {
  width: 50px !important;
  height: 50px !important;
}

.viewer img {
  width: 100% !important;
  height: 100% !important;
}

.table-div {
  height: 30px;
  width: 100%;
  overflow: hidden;
  line-height: 30px;
  border-right: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
}

.table-div:last-child {
  border-bottom: 1px solid #ebeef5;
}

.table-div p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wcgplan/ScheduleList.vue